var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ItemGroupList',{attrs:{"memory-key":"item-groups"}})
}
var staticRenderFns = []

export { render, staticRenderFns }